import "./DashboardNews.css";

const DashboardNews = () => {
  return (
    <div className="dashboardNews">
      <div className="dashboardNews__container flex-column">
        <div>
          <h3>New Update Coming This Month</h3>
          <p>
            wealth creation is an evolutionarily recent positive-sum game. it is
            all about how to take the opportunity first.
          </p>
        </div>
        <a target="_blank" rel="noreferrer" href="https://discord.com/app">
          <button className="btn">
            Join Now
            <svg
              width="14"
              height="10"
              viewBox="0 0 16 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 5.78049L14.7071 6.48759L15.4142 5.78049L14.7071 5.07338L14 5.78049ZM9.92662 0.292893C9.53609 -0.0976311 8.90293 -0.0976311 8.51241 0.292893C8.12188 0.683418 8.12188 1.31658 8.51241 1.70711L9.92662 0.292893ZM0 6.78049H14V4.78049H0V6.78049ZM13.2929 5.07338L8.51241 9.85387L9.92662 11.2681L14.7071 6.48759L13.2929 5.07338ZM14.7071 5.07338L9.92662 0.292893L8.51241 1.70711L13.2929 6.48759L14.7071 5.07338Z"
                fill="white"
              />
            </svg>
          </button>
        </a>
      </div>
    </div>
  );
};

export default DashboardNews;
